import React from 'react';

import { type Sources } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

type SourcesContext = {
	sources?: Sources;
};

export const SourcesContext: React.Context<SourcesContext> = React.createContext<SourcesContext>({
	sources: [],
});

export const useMessageSources = (): SourcesContext => React.useContext(SourcesContext);
